import { formatDateInputDisplay } from '@/utils/dateInput';

/**
 * The label a static-column entity reads as in a cell or a filter option.
 * Most entities carry a `name`; dates don't, so they read as their date.
 */
export function staticEntityName(entity: unknown): string {
  if (typeof entity !== 'object' || entity === null) return '';
  const record = entity as { name?: unknown; date?: unknown };
  if (typeof record.name === 'string') return record.name;
  if (typeof record.date === 'string') return formatDateInputDisplay(record.date) || record.date;
  return '';
}
